import { ReactNode, useMemo } from 'react'

import { ChainHealthBanner } from '~/components/Layout/ChainHealthBanner'
import { GasAlertBanner } from '~/components/Layout/GasAlertBanner'
import { ViewAsBanner } from '~/components/Layout/ViewAsBanner'
import { useGasAlert, useIsOrgOverridden } from '~/hooks/org'
import { useAuthUser } from '~/hooks/useAuthUser'
import { useStalledChainIds } from '~/hooks/useChainHealth'

/**
 * Determine if the global page banner should be shown.
 */
export const useBanner = () => {
  const stalledChains = useStalledChainIds()
  const isOrgOverridden = useIsOrgOverridden()
  const { user: authUser } = useAuthUser()
  const gasAlert = useGasAlert()

  const showBanner =
    authUser && (stalledChains.size > 0 || isOrgOverridden || !!gasAlert)

  const banner: ReactNode = useMemo(() => {
    if (!showBanner) return
    if (isOrgOverridden) return <ViewAsBanner />
    if (stalledChains.size > 0) return <ChainHealthBanner />
    if (gasAlert) return <GasAlertBanner />
  }, [showBanner, isOrgOverridden, stalledChains, gasAlert])

  return {
    stalledChains,
    isOrgOverridden,
    showBanner,
    banner,
  }
}
